import api from '@/store/api/customer'
import * as mutationTypes from './mutation-types'
// Modules
import activities from './activities'
import cancellations from './cancellations'
import subaccounts from './subaccounts'
import contacts from './contacts'
import contracts from './contracts'
import invoices from './invoices'
import metrics from './metrics'
import mfa from './mfa'
import products from './products'
import propertyHistory from './property-history'
import userLogs from './user-logs'
import { handleApiCall } from '@/store/utils'

const initialState = () => ({
    customer: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        customer: state => state.customer
    },
    actions: {
        /**
         * @param {{customerId: number}} data
         * @returns {Promise<*>}
         */
        showCustomer: ({ commit, dispatch }, data) => handleApiCall({ commit, dispatch }, api.showCustomer, data, mutationTypes.SET_CUSTOMER),
        resetCustomer: async ({commit}) => commit(mutationTypes.RESET_CUSTOMER)
    },
    modules: {
        activities,
        cancellations,
        contacts,
        subaccounts,
        contracts,
        invoices,
        metrics,
        mfa,
        products,
        propertyHistory,
        userLogs
    },
    mutations: {
        [mutationTypes.SET_CUSTOMER]: (state, data) => state.customer = data,
        [mutationTypes.RESET_CUSTOMER]: (state) => Object.assign(state, initialState())
    }
}
